import { render } from "./Customize.vue?vue&type=template&id=8f9920a8&scoped=true&ts=true"
import script from "./Customize.vue?vue&type=script&lang=ts"
export * from "./Customize.vue?vue&type=script&lang=ts"

import "./Customize.vue?vue&type=style&index=0&id=8f9920a8&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f9920a8"]])

export default __exports__